import Vue from 'vue';
import {
  Button,
  Row,
  Col,
  Input,
  Form,
  FormItem,
  Message,
  Tooltip,
  Collapse,
  CollapseItem,
} from 'element-ui';

Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.use(Tooltip);

Vue.prototype.$message = Message;
